module.exports = __webpack_public_path__ + "static/media/00-main02-sp_4x.2c20cbb7.png";